import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import "core-js/modules/es.symbol.js";
import "core-js/modules/es.array.filter.js";
import "core-js/modules/es.array.push.js";
import "core-js/modules/es.object.get-own-property-descriptor.js";
import "core-js/modules/es.object.get-own-property-descriptors.js";
import "core-js/modules/es.object.keys.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.promise.js";
import "core-js/modules/esnext.iterator.constructor.js";
import "core-js/modules/esnext.iterator.filter.js";
import "core-js/modules/esnext.iterator.for-each.js";
import "core-js/modules/web.dom-collections.for-each.js";
import { Core } from "@faire/design-tokens";
import { FileUploader } from "@faire/help-center-self-serve/components/FileUploader/FileUploader";
import { Column, FormField } from "@faire/web--source/slate/Layout";
import { Spacer } from "@faire/web--source/slate/spacing";
import { Typography } from "@faire/web--source/slate/Typography";
import { useState } from "@faire/web--source/ui/hooks/useState";
import { StrictLocalMsg } from "@faire/web--source/ui/lib/localization";
import React from "react";
var TEN_MEGA_BYTES = 10 * 1024 * 1024;
export var AttachmentFormField = function AttachmentFormField(_ref) {
  var attachment = _ref.attachment,
    setAttachment = _ref.setAttachment;
  var _useState = useState(undefined),
    _useState2 = _slicedToArray(_useState, 2),
    attachmentError = _useState2[0],
    setAttachmentError = _useState2[1];
  var handleFileSelected = function handleFileSelected(file) {
    setAttachmentError(undefined);
    setAttachment(file);
    return Promise.resolve();
  };
  var clearAttachment = function clearAttachment() {
    setAttachmentError(undefined);
    setAttachment(undefined);
  };
  return /*#__PURE__*/React.createElement(FormField, {
    "$name": "attachment",
    style: {
      width: "100%"
    }
  }, /*#__PURE__*/React.createElement(Typography, _objectSpread({}, attachmentError ? {
    color: Core.text.critical
  } : {}), /*#__PURE__*/React.createElement(AttachmentLabel, null)), /*#__PURE__*/React.createElement(Spacer, {
    height: "1x"
  }), /*#__PURE__*/React.createElement(FileUploader, {
    currentFile: attachment,
    onUploadSuccess: handleFileSelected,
    onUploadError: setAttachmentError,
    onRemoveFile: clearAttachment,
    uploadCta: /*#__PURE__*/React.createElement(AttachmentInstructions, null),
    accepts: ".pdf, .jpg, .jpeg, .png",
    maxFileSize: TEN_MEGA_BYTES,
    showFileIcon: false,
    height: 150
  }), /*#__PURE__*/React.createElement(Spacer, {
    height: "1x"
  }), /*#__PURE__*/React.createElement(Typography, {
    color: Core.text.subdued,
    variant: "labelSansRegular"
  }, /*#__PURE__*/React.createElement(HelperMessage, null)));
};
var AttachmentLabel = function AttachmentLabel() {
  return /*#__PURE__*/React.createElement(StrictLocalMsg, {
    id: "VpRIOk",
    defaultMessage: "Attachment (optional)"
  });
};
var HelperMessage = function HelperMessage() {
  return /*#__PURE__*/React.createElement(StrictLocalMsg, {
    id: "MfUomi",
    defaultMessage: "Upload a photo or screenshot of the issue if needed"
  });
};
var AttachmentInstructions = function AttachmentInstructions() {
  return /*#__PURE__*/React.createElement(Column, {
    gap: 5
  }, /*#__PURE__*/React.createElement(Typography, {
    align: "center",
    color: Core.text.default
  }, /*#__PURE__*/React.createElement(StrictLocalMsg, {
    id: "ICOW4i",
    defaultMessage: "Drag and drop here or <u>upload a file</u>"
  })), /*#__PURE__*/React.createElement(Typography, {
    align: "center",
    color: "inherit",
    variant: "labelSansRegular"
  }, /*#__PURE__*/React.createElement(StrictLocalMsg, {
    id: "YW7q3F",
    defaultMessage: "Accepts JPG, PNG, or PDF up to 10MB"
  })));
};